import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { PointStatuses } from '@app/models';
import { POINT_STATUS_CONFIG } from '../order-status.const';

@Component({
  selector: 'ui-order-indicator',
  standalone: true,
  imports: [NgClass],
  templateUrl: './order-indicator.component.html',
  styleUrl: './order-indicator.component.scss',
})
export class OrderIndicatorComponent {
  public readonly pointStatus = input<PointStatuses>();

  protected readonly PointStatuses = PointStatuses;

  protected readonly config = computed(
    () => POINT_STATUS_CONFIG[this.pointStatus() || PointStatuses.READY],
  );
}
